import { createContext, useContext, useState, useEffect } from 'react';

const AgeVerificationContext = createContext(null);

export function AgeVerificationProvider({ children }) {
  const [isVerified, setIsVerified] = useState(() => {
    return localStorage.getItem('ageVerified') === 'true';
  });

  const verify = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVerified(true);
  };

  const reset = () => {
    localStorage.removeItem('ageVerified');
    setIsVerified(false);
  };

  return (
    <AgeVerificationContext.Provider value={{ isVerified, verify, reset }}>
      {children}
    </AgeVerificationContext.Provider>
  );
}

export function useAgeVerification() {
  const context = useContext(AgeVerificationContext);
  if (!context) {
    throw new Error('useAgeVerification must be used within an AgeVerificationProvider');
  }
  return context;
}
